import React from 'react'
import "../Home"
import {Link} from 'react-router-dom'
function NewHeader(props) {
  return (
    <div>
            <div className="Navbar">
      <div>
        <img className="logo" src="/cleverpewhitehori.png" alt="logo" />
      </div>
      <div>
        <Link to="/"><span className={`mx-3 home-link ${props.id===1&&'home-link-active'}`}>Home</span></Link>
        <Link to="/aboutus"><span className={`mx-3 home-link ${props.id===2&&'home-link-active'}`}>About</span></Link>
      </div>
      <div>
      <div className="button desktop-visible">
        <button onClick={()=>window.location.href="https://business.cleverpe.com/"} className="white-button">Merchants</button>
      </div>
      </div>
   </div>
    </div>
  )
}

export default NewHeader